//
// MapUnits.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */

var MapUnits = {
    INVALID:0,
    DEGREE:1,
    METER:2,
    KILOMETER:3,
    FOOT:4,
    MILE:5,
    INCH:6,
    HOUR:7,
    MINUTE:8,
    SECOND:9
};
export default MapUnits;
